// Icon map object type
export type IMap = Record<
  string,
  {
    readonly viewDim: string
    readonly viewDimY?: string
    readonly paths: IPath[]
  }
>

// SVG path interface
export interface IPath {
  readonly d: string 
  readonly fillOpacity: string
}

// Icons map
const iconsMap: IMap = {
  // Outlined angle down
  angleDown: {
    viewDim: '16',
    viewDimY: '10',
    paths: [
      {
        d: 'M7.3782 9.59737L0.257605 2.47667C-0.0858945 2.13327 -0.0858945 1.57647 0.257606 1.23317L1.08811 0.40257C1.43091 0.0597696 1.9866 0.0591696 2.3302 0.40117L8 6.04437L13.6698 0.40107C14.0134 0.05907 14.5691 0.0597702 14.9119 0.40257L15.7424 1.23307C16.0859 1.57647 16.0859 2.13327 15.7424 2.47667L8.6218 9.59727C8.2784 9.94077 7.7216 9.94077 7.3782 9.59737Z',
        fillOpacity: '1',
      },
    ],
  },
  // Filled outlined angle left
  angleLeft: {
    viewDim: '36',
    paths: [
      {
        d: 'M13.4026 17.3782L20.5233 10.2576C20.8667 9.91415 21.4235 9.91415 21.7668 10.2576L22.5974 11.0881C22.9402 11.4309 22.9409 11.9866 22.5988 12.3302L16.9556 18L22.5989 23.6698C22.9409 24.0134 22.9402 24.5691 22.5974 24.9119L21.7669 25.7424C21.4235 26.0859 20.8667 26.0859 20.5233 25.7424L13.4027 18.6218C13.0592 18.2784 13.0592 17.7216 13.4026 17.3782Z',
        fillOpacity: '0.5',
      },
    ],
  },
  // Filled outlined angle right
  angleRight: {
    viewDim: '36',
    paths: [
      {
        d: 'M22.5974 18.6218L15.4767 25.7424C15.1333 26.0859 14.5765 26.0859 14.2332 25.7424L13.4026 24.9119C13.0598 24.5691 13.0592 24.0134 13.4012 23.6698L19.0444 18L13.4011 12.3302C13.0591 11.9866 13.0598 11.4309 13.4026 11.0881L14.2331 10.2576C14.5765 9.91414 15.1333 9.91414 15.4767 10.2576L22.5973 17.3782C22.9408 17.7216 22.9408 18.2784 22.5974 18.6218Z',
        fillOpacity: '0.5',
      },
    ],
  },
  // Filled outline close
  cross: {
    viewDim: '36',
    paths: [
      {
        d: 'M18 16.0407L22.9168 11.2254C23.2236 10.9249 23.721 10.9249 24.0279 11.2254L24.7699 11.9521C25.0762 12.252 25.0768 12.7382 24.7712 13.0389L19.7293 18L24.7712 22.9611C25.0767 23.2618 25.0762 23.748 24.7699 24.0479L24.0278 24.7746C23.721 25.0751 23.2236 25.0751 22.9168 24.7746L18 19.9593L13.0832 24.7746C12.7764 25.0751 12.279 25.0751 11.9722 24.7746L11.2301 24.0479C10.9238 23.748 10.9233 23.2618 11.2288 22.9611L16.2707 18L11.2288 13.0389C10.9232 12.7382 10.9238 12.252 11.2301 11.9521L11.9721 11.2254C12.279 10.9249 12.7764 10.9249 13.0832 11.2254L18 16.0407Z',
        fillOpacity: '0.5',
      },
    ],
  },
  // Solid hamburger
  hamburger: {
    viewDim: '23',
    paths: [
      {
        d: 'M21.2188 18.8125H0.90625C0.69905 18.8125 0.500336 18.8948 0.353823 19.0413C0.20731 19.1878 0.125 19.3865 0.125 19.5938L0.125 21.1562C0.125 21.3635 0.20731 21.5622 0.353823 21.7087C0.500336 21.8552 0.69905 21.9375 0.90625 21.9375H21.2188C21.426 21.9375 21.6247 21.8552 21.7712 21.7087C21.9177 21.5622 22 21.3635 22 21.1562V19.5938C22 19.3865 21.9177 19.1878 21.7712 19.0413C21.6247 18.8948 21.426 18.8125 21.2188 18.8125ZM21.2188 12.5625H0.90625C0.69905 12.5625 0.500336 12.6448 0.353823 12.7913C0.20731 12.9378 0.125 13.1365 0.125 13.3438L0.125 14.9062C0.125 15.1135 0.20731 15.3122 0.353823 15.4587C0.500336 15.6052 0.69905 15.6875 0.90625 15.6875H21.2188C21.426 15.6875 21.6247 15.6052 21.7712 15.4587C21.9177 15.3122 22 15.1135 22 14.9062V13.3438C22 13.1365 21.9177 12.9378 21.7712 12.7913C21.6247 12.6448 21.426 12.5625 21.2188 12.5625ZM21.2188 6.3125H0.90625C0.69905 6.3125 0.500336 6.39481 0.353823 6.54132C0.20731 6.68784 0.125 6.88655 0.125 7.09375L0.125 8.65625C0.125 8.86345 0.20731 9.06216 0.353823 9.20868C0.500336 9.35519 0.69905 9.4375 0.90625 9.4375H21.2188C21.426 9.4375 21.6247 9.35519 21.7712 9.20868C21.9177 9.06216 22 8.86345 22 8.65625V7.09375C22 6.88655 21.9177 6.68784 21.7712 6.54132C21.6247 6.39481 21.426 6.3125 21.2188 6.3125ZM21.2188 0.0625H0.90625C0.69905 0.0625 0.500336 0.14481 0.353823 0.291323C0.20731 0.437836 0.125 0.63655 0.125 0.84375L0.125 2.40625C0.125 2.61345 0.20731 2.81216 0.353823 2.95868C0.500336 3.10519 0.69905 3.1875 0.90625 3.1875H21.2188C21.426 3.1875 21.6247 3.10519 21.7712 2.95868C21.9177 2.81216 22 2.61345 22 2.40625V0.84375C22 0.63655 21.9177 0.437836 21.7712 0.291323C21.6247 0.14481 21.426 0.0625 21.2188 0.0625Z',
        fillOpacity: '1',
      },
    ],
  },
}

export default iconsMap
